module.exports = "img/admin.1968ad5.svg";